<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Staff Tracking Report</h1>

    <!-- Utility Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button mat-raised-button color="primary" class="me-1 mb-1" (click)="refreshData()">
          Refresh
        </button>
        <button (click)="exportReport()"
          color="primary"
          mat-flat-button
          class="me-1 mb-1 warning">
          <mat-icon>file_download</mat-icon>
          <span>Export</span>
        </button>
        <button style="background-color: transparent !important; border: none;"
          (click)="printReport()"
          type="button"
          mat-icon-button
          class="mb-1"
          matTooltip="Print staff tracking report"
          matTooltipPosition="below"
          aria-label="Print staff tracking report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Filter</mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]="queryParams"></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form #f="ngForm" class="form">
      <div class="row">
        <app-week-year-selector
          [showDateRange]="true"
          [initialWeek]="week"
          [initialYear]="year"
          [initialDateRange]="dateTimeRange"
          (selectionChange)="onWeekYearChange($event)">
        </app-week-year-selector>

        <section class="section">
          <div class="float-end bring-inline">
            <button (click)="resetForm()" color="primary" mat-flat-button class="me-1">
              Clear
            </button>
          </div>
        </section>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <!-- Staff Tables -->
  <div class="row">
    <div class="col-md-4 col-sm-6 col-xs-12 mt-4" *ngFor="let staff of staffData">
      <h3>{{staff.name}} <!--({{staff.job_title}})--></h3>

      <table mat-table [dataSource]="getStaffData(staff)" class="w-100">
        <!-- Period Column -->
        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>Period</th>
          <td mat-cell *matCellDef="let element">{{element.period}}</td>
        </ng-container>

        <!-- Lessons Taught Column -->
        <ng-container matColumnDef="lessons_taught">
          <th mat-header-cell *matHeaderCellDef>
            Lessons Taught
            <mat-icon class="help-icon-inline" matTooltip="Count of lessons in the period where this staff member was the instructor and the lesson status is Showed, No Showed Charged, or Canceled Too Late.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let element">{{element.lessons_taught || ''}}</td>
        </ng-container>

        <!-- Lesson Sales Column -->
        <ng-container matColumnDef="lesson_sales">
          <th mat-header-cell *matHeaderCellDef class="text-end">
            Lesson Sales
            <mat-icon class="help-icon-inline" matTooltip="Staff member's share of the contract value of package enrollments sold in the period, weighted by their Instructors (%) split. Reflects the full sale amount, not just cash collected. Excludes Miscellaneous categories.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let element" class="text-end">{{ element.lesson_sales ? (element.lesson_sales | studioCurrency) : '' }}</td>
        </ng-container>

        <!-- Misc Sales Column -->
        <ng-container matColumnDef="misc_sales">
          <th mat-header-cell *matHeaderCellDef class="text-end">
            Misc Sales
            <mat-icon class="help-icon-inline" matTooltip="Staff member's share of the contract value of Miscellaneous-category enrollments sold in the period, weighted by their Instructors (%) split.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let element" class="text-end">{{ element.misc_sales ? (element.misc_sales | studioCurrency) : '' }}</td>
        </ng-container>

        <!-- Cash Column -->
        <ng-container matColumnDef="cash">
          <th mat-header-cell *matHeaderCellDef class="text-end">
            Cash
            <mat-icon class="help-icon-inline" matTooltip="Cash this staff member produced in the period: gross tuition from payments dated in the period, weighted by the linked enrollment's Instructors (%) split.">help_outline</mat-icon>
          </th>
          <td mat-cell *matCellDef="let element" class="text-end">{{ element.cash ? (element.cash | studioCurrency) : '' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
